export default "__VITE_ASSET__4501bc62__"